const BONUS_REPAIR_PRODUCT_MAP = [
  { produit: 'Lave-Linge', mapping: 'lave-linge' },
  { produit: 'Réfrigérateur', mapping: 'réfrigérateur' },
  { produit: 'Aspirateur', mapping: 'aspirateurs (balai / robot / traineau)' },
  { produit: 'Lave-Vaiselle', mapping: 'lave-vaisselle' },
  { produit: 'Blender', mapping: null },
  { produit: 'Machine à café', mapping: ['machine à café à capsule', 'machine à café avec filtre', 'machine à café tout automatique'] },
  { produit: 'Cave à vin', mapping: 'cave à vin' },
  { produit: 'Grille-pain', mapping: 'grille-pain' },
  { produit: 'Hotte', mapping: 'hotte' },
  { produit: 'Chauffe-eau', mapping: null },
  { produit: 'Sèche-Linge', mapping: 'sèche-linge' },
  { produit: 'Congélateur', mapping: 'congélateur' },
  { produit: 'Barbecue', mapping: null },
  { produit: 'Friteuse', mapping: 'friteuse' },
  { produit: 'Radiateur', mapping: null },
  { produit: 'Climatiseur', mapping: 'climatiseur mobile' },
  { produit: 'Four', mapping: ['four micro-ondes', 'four posable', 'four encastrable (hors micro-ondes)'] },
  { produit: 'Plaque de cuisson', mapping: 'plaque de cuisson' },
  { produit: 'Autres', mapping: null }
];

export { BONUS_REPAIR_PRODUCT_MAP };
